export default {
    'ERROR-GET-ALL-INTERCONNECTIONS-DATA': {
        'HUBSPOT-INTERCONNECTION-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Interconnexion HubSpot non trouvée.",
                en: 'HubSpot interconnection not found.',
            },
        },
        'EXISTING-PROPERTIES-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Propriétés existantes non trouvées pour l'interconnexion HubSpot.",
                en: 'Existing properties not found for HubSpot interconnection.',
            },
        },
        'EXISTING-PROPERTIES-EMPTY': {
            actionType: 'toast',
            message: {
                fr: "Aucune propriété existante pour l'interconnexion HubSpot.",
                en: 'No existing properties for HubSpot interconnection.',
            },
        },
    },
    'ERROR-UPDATE-HUBSPOT-MAPPING-FIELDS': {
        'MAPPING-FIELDS-MISSING': {
            actionType: 'toast',
            message: {
                fr: 'Tous les champs de mapping sont requis.',
                en: 'All mapping fields are required.',
            },
        },
        'MAPPING-FIELDS-ERROR-SAME-VALUE': {
            actionType: 'toast',
            message: {
                fr: 'Les champs de mapping ne peuvent pas avoir la même valeur.',
                en: 'Mapping fields cannot have the same value.',
            },
        },
        'HUBSPOT-INTERCONNECTION-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Interconnexion HubSpot non trouvée.",
                en: 'HubSpot interconnection not found.',
            },
        },
        'EXISTING-PROPERTIES-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Propriétés existantes non trouvées pour l'interconnexion HubSpot.",
                en: 'Existing properties not found for HubSpot interconnection.',
            },
        },
        'MAPPING-FIELDS-ERROR': {
            actionType: 'toast',
            message: {
                fr: 'Les champs de mapping ne correspondent pas aux propriétés existantes.',
                en: 'Mapping fields do not match existing properties.',
            },
        },
    },
    'ERROR-UPDATE-HUBSPOT-DATA-OVERWRITE-STRATEGY': {
        'DATA-SYNC-STRATEGY-WRONG-VALUE': {
            actionType: 'toast',
            message: {
                fr: 'Valeur incorrecte pour la stratégie de synchronisation des données.',
                en: 'Incorrect value for data sync strategy.',
            },
        },
        'HUBSPOT-INTERCONNECTION-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Interconnexion HubSpot non trouvée.",
                en: 'HubSpot interconnection not found.',
            },
        },
    },
};
